import { ResourceCategory } from './resource-category';

export class Resource {
    public ResourceId:string;

    public ResourceUrl:string;

    public Name:string;

    public Description:string;

    public ResourceCategoryId:string;

    public ResourceCategory:ResourceCategory;

    public SortOrder:number;

    public DateAdded:string;

    public LastUpdatedDate:string;

    public IsDeleted:boolean;

    constructor(ResourceId:string = "", Name:string = ""){
        this.ResourceId = ResourceId;
        this.Name = Name;
    }

}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/ng-router-loader?{"loader":"async-system","genDir":"compiled","aot":false}!./src/app/entities/resource.ts